export const SET_CONTENT_FILTER = 'SET_CONTENT_FILTER'

export function setContentFilter(contentVehicle, contentType, contentId) {
  return {
    type: SET_CONTENT_FILTER,
    contentVehicle,
    contentType,
    contentId
  }
}



// WEBPACK FOOTER //
// ./src/actions/contentFilter.js